
import { storage } from '../lib/storage';
import { AuctionEvent, Bid, Product } from '../types';

const STORAGE_KEY = 'lynqar_auctions';

export const auctionService = {
  getStoreAuctions: (storeId: string): AuctionEvent[] => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: AuctionEvent[] = data ? JSON.parse(data) : [];
    return all.filter(a => a.storeId === storeId);
  },

  getActiveAuction: (storeId?: string): AuctionEvent | null => {
    const data = localStorage.getItem(STORAGE_KEY);
    const all: AuctionEvent[] = data ? JSON.parse(data) : [];
    const now = new Date();
    return all.find(a => {
      const start = new Date(a.startTime);
      const end = new Date(a.endTime);
      const matchesStore = storeId ? a.storeId === storeId : true;
      return matchesStore && now >= start && now <= end && a.status === 'ACTIVE';
    }) || null;
  },

  saveAuction: (auction: AuctionEvent) => {
    const data = localStorage.getItem(STORAGE_KEY);
    let all: AuctionEvent[] = data ? JSON.parse(data) : [];
    const idx = all.findIndex(a => a.id === auction.id);
    if (idx !== -1) all[idx] = auction;
    else all.push(auction);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    window.dispatchEvent(new Event('auction-update'));
  },

  placeBid: (auctionId: string, userId: string, userName: string, amount: number) => {
    const data = localStorage.getItem(STORAGE_KEY);
    if (!data) return null;
    const all: AuctionEvent[] = JSON.parse(data);
    const auction = all.find(a => a.id === auctionId);
    
    if (!auction || auction.status !== 'ACTIVE') return null;
    if (amount <= auction.currentPrice) return null;

    const newBid: Bid = {
      id: 'bid-' + Date.now(),
      userId,
      userName,
      amount,
      timestamp: new Date().toISOString()
    };

    auction.bids.push(newBid);
    auction.currentPrice = amount;
    
    // Sniping protection: If bid in last 30s, extend by 30s
    const end = new Date(auction.endTime).getTime();
    const now = new Date().getTime();
    if (end - now < 30000) {
      auction.endTime = new Date(now + 60000).toISOString();
    }

    auctionService.saveAuction(auction);
    return auction;
  }
};
